module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-10-efa13f9c641008a4c18b9cd300b7bc37.jpg";